module.exports = __webpack_public_path__ + "assets/icons/ic_filter_list-7336.svg";